export const toMusts = (value: unknown): string[] => {
  if (value == null || value === '') {
    return [];
  }
  const items = Array.isArray(value) ? value : [value];
  return items.map((item) => String(item ?? '').trim()).filter(Boolean);
};

export const pickMusts = (...candidates: unknown[]): string[] => {
  for (const candidate of candidates) {
    if (candidate == null || candidate === '') {
      continue;
    }
    return toMusts(candidate);
  }
  return [];
};
